import { Container } from "react-bootstrap"
import EditProfileForm from "../../components/EditProfileForm/EditProfileForm"

const EditPage = () => {

    return (
        <Container style={{ height: '100vh' }} >
            <EditProfileForm />
        </Container>
    )

}


export default EditPage